import { useClerk } from "@clerk/clerk-react";
import { useCallback } from "react";

import { setPreferredOrganizationId } from "@/utils/organization";

/**
 * Opens another organization: remembered first, so the next boot lands there
 * rather than on whichever Clerk had active, then a full load of the dashboard.
 */
export const useOpenOrganization = () => {
  const { setActive } = useClerk();

  return useCallback(
    async (organizationId: string) => {
      setPreferredOrganizationId(organizationId);
      await setActive({ organization: organizationId });
      window.location.href = "/dashboard";
    },
    [setActive],
  );
};
